const rrdefs = [
    {
        attributes: {delegate: 'add-External functions', dir: 'OUT', path: '/iot/{sensorid}', tcmd: 'add-events', tinstance: '{sensorId}',ttype: ""},
        id: "gpMkDvxs1djGmzTfbV1q3g",
        name: "rrdef1",
        type: 13   
    }
]
export default rrdefs